import type { FoodOption } from "@/data/meal-plan/types.ts";

// ── Carbs ──
// IMPORTANT: Preserve original item positions (indices) for backward compatibility
// with saved plans. New items must be appended at the end.

export const ROMINA_BREAKFAST_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Avena cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Avena en hojuelas cruda (USDA)",
    per100g: { calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    perPortion: { calories: 97.3, protein: 4.2, carbs: 16.6, fat: 1.7 },
  }},
  /* 1 */ { id: "1", name: "Pan de molde", portion: "1 und", nutrition: {
    sourceName: "Pan de Molde Blanco Bimbo",
    per100g: { calories: 259, protein: 8.9, carbs: 44.1, fat: 4.2 },
    perPortion: { calories: 72.5, protein: 2.5, carbs: 12.3, fat: 1.2 },
  }},
  /* 2 */ { id: "2", name: "Pan pita", portion: "1 und", nutrition: {
    sourceName: "Pan Pita (USDA)",
    per100g: { calories: 275, protein: 9.1, carbs: 55.7, fat: 1.2 },
    perPortion: { calories: 123.8, protein: 4.1, carbs: 25.1, fat: 0.5 },
  }},
  /* 3 */ { id: "3", name: "Rapidita", portion: "1 und", nutrition: {
    sourceName: "Tortillas Rapiditas Clásicas Bimbo",
    per100g: { calories: 284, protein: 7.7, carbs: 48.1, fat: 6.7 },
    perPortion: { calories: 73.8, protein: 2.0, carbs: 12.5, fat: 1.7 },
  }},
  /* 4 */ { id: "4", name: "Tostada", portion: "1 und", nutrition: {
    sourceName: "Pan Tostado Clásico Bimbo",
    per100g: { calories: 400, protein: 10.5, carbs: 73, fat: 7.7 },
    perPortion: { calories: 64.0, protein: 1.7, carbs: 11.7, fat: 1.2 },
  }},
  /* 5 -- was "Fruta" placeholder, kept for backward compat */
  { id: "5", name: "Fruta (ver opciones de fruta)", portion: "1 opcion" },
  // ── New options (appended) ──
  { id: "6", name: "Arandanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arandanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "7", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
  { id: "8", name: "Mandarinas", portion: "2 und medianas (176 g)", grams: 176, nutrition: {
    sourceName: "Mandarina fresca (USDA)",
    per100g: { calories: 53, protein: 0.8, carbs: 13.3, fat: 0.3 },
    perPortion: { calories: 93.3, protein: 1.4, carbs: 23.4, fat: 0.5 },
  }},
];

export const ROMINA_MID_AFTERNOON_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Avena cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Avena en hojuelas cruda (USDA)",
    per100g: { calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    perPortion: { calories: 97.3, protein: 4.2, carbs: 16.6, fat: 1.7 },
  }},
  /* 1 */ { id: "1", name: "Pan de molde", portion: "1 und", nutrition: {
    sourceName: "Pan de Molde Blanco Bimbo",
    per100g: { calories: 259, protein: 8.9, carbs: 44.1, fat: 4.2 },
    perPortion: { calories: 72.5, protein: 2.5, carbs: 12.3, fat: 1.2 },
  }},
  /* 2 */ { id: "2", name: "Pan pita", portion: "1 und", nutrition: {
    sourceName: "Pan Pita (USDA)",
    per100g: { calories: 275, protein: 9.1, carbs: 55.7, fat: 1.2 },
    perPortion: { calories: 123.8, protein: 4.1, carbs: 25.1, fat: 0.5 },
  }},
  /* 3 */ { id: "3", name: "Rapidita", portion: "1 und", nutrition: {
    sourceName: "Tortillas Rapiditas Clásicas Bimbo",
    per100g: { calories: 284, protein: 7.7, carbs: 48.1, fat: 6.7 },
    perPortion: { calories: 73.8, protein: 2.0, carbs: 12.5, fat: 1.7 },
  }},
  /* 4 */ { id: "4", name: "Tostada", portion: "1 und", nutrition: {
    sourceName: "Pan Tostado Clásico Bimbo",
    per100g: { calories: 400, protein: 10.5, carbs: 73, fat: 7.7 },
    perPortion: { calories: 64.0, protein: 1.7, carbs: 11.7, fat: 1.2 },
  }},
  /* 5 -- was "Fruta" placeholder, kept for backward compat */
  { id: "5", name: "Fruta (ver opciones de fruta)", portion: "1 opcion" },
  /* 6 */ { id: "6", name: "Galleta Club Social", portion: "1 paquete", nutrition: {
    sourceName: "Club Social Original Nabisco",
    per100g: { calories: 442, protein: 7.7, carbs: 65.4, fat: 17.3 },
    perPortion: { calories: 114.9, protein: 2.0, carbs: 17.0, fat: 4.5 },
  }},
  // ── New options (appended) ──
  { id: "7", name: "Arandanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arandanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "8", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
  { id: "9", name: "Mandarinas", portion: "2 und medianas (176 g)", grams: 176, nutrition: {
    sourceName: "Mandarina fresca (USDA)",
    per100g: { calories: 53, protein: 0.8, carbs: 13.3, fat: 0.3 },
    perPortion: { calories: 93.3, protein: 1.4, carbs: 23.4, fat: 0.5 },
  }},
];

export const ROMINA_LUNCH_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Arroz blanco", portion: "50 g", grams: 50, nutrition: {
    sourceName: "Arroz blanco cocido grano largo (USDA #168878)",
    per100g: { calories: 130, protein: 2.7, carbs: 28.2, fat: 0.3 },
    perPortion: { calories: 65, protein: 1.4, carbs: 14.1, fat: 0.2 },
  }},
  /* 1 */ { id: "1", name: "Arroz integral", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Arroz integral cocido grano largo (USDA #169704)",
    per100g: { calories: 123, protein: 2.7, carbs: 25.6, fat: 1.0 },
    perPortion: { calories: 86.1, protein: 1.9, carbs: 17.9, fat: 0.7 },
  }},
  /* 2 -- was "Menestras", renamed to Lentejas in-place (same nutritional data) */
  { id: "2", name: "Lentejas", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Lentejas cocidas hervidas (USDA #172421)",
    per100g: { calories: 116, protein: 9.0, carbs: 20.1, fat: 0.4 },
    perPortion: { calories: 92.8, protein: 7.2, carbs: 16.1, fat: 0.3 },
  }},
  /* 3 */ { id: "3", name: "Papa", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Papa hervida sin piel (USDA #170440)",
    per100g: { calories: 86, protein: 1.7, carbs: 20.0, fat: 0.1 },
    perPortion: { calories: 60.2, protein: 1.2, carbs: 14.0, fat: 0.1 },
  }},
  /* 4 */ { id: "4", name: "Yuca", portion: "45 g", grams: 45, nutrition: {
    sourceName: "Yuca cocida hervida (USDA estimado)",
    per100g: { calories: 155, protein: 1.4, carbs: 37.5, fat: 0.3 },
    perPortion: { calories: 69.8, protein: 0.6, carbs: 16.9, fat: 0.1 },
  }},
  /* 5 */ { id: "5", name: "Choclo", portion: "63 g", grams: 63, nutrition: {
    sourceName: "Maiz dulce amarillo cocido hervido (USDA #169999)",
    per100g: { calories: 96, protein: 3.4, carbs: 21.0, fat: 1.5 },
    perPortion: { calories: 60.5, protein: 2.1, carbs: 13.2, fat: 0.9 },
  }},
  /* 6 */ { id: "6", name: "Fideos blancos", portion: "48 g", grams: 48, nutrition: {
    sourceName: "Pasta cocida enriquecida (USDA #169737)",
    per100g: { calories: 158, protein: 5.8, carbs: 30.9, fat: 0.9 },
    perPortion: { calories: 75.8, protein: 2.8, carbs: 14.8, fat: 0.4 },
  }},
  /* 7 */ { id: "7", name: "Fideos integrales", portion: "53 g", grams: 53, nutrition: {
    sourceName: "Pasta integral cocida (USDA #168910)",
    per100g: { calories: 149, protein: 6.0, carbs: 30.1, fat: 1.7 },
    perPortion: { calories: 79.0, protein: 3.2, carbs: 16.0, fat: 0.9 },
  }},
  /* 8 */ { id: "8", name: "Guiso (locro, olluquito, etc.)", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Guiso peruano promedio cocido (estimado)",
    per100g: { calories: 100, protein: 5.0, carbs: 15.0, fat: 2.0 },
    perPortion: { calories: 80.0, protein: 4.0, carbs: 12.0, fat: 1.6 },
  }},
  // ── New options (appended) ──
  { id: "9", name: "Arvejita partida", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Arvejas partidas cocidas hervidas (USDA #175216)",
    per100g: { calories: 118, protein: 8.34, carbs: 21.1, fat: 0.4 },
    perPortion: { calories: 94.4, protein: 6.7, carbs: 16.9, fat: 0.3 },
  }},
  { id: "10", name: "Frejol", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Frijoles pintos cocidos hervidos (USDA #175194)",
    per100g: { calories: 143, protein: 9.0, carbs: 26.2, fat: 0.65 },
    perPortion: { calories: 114.4, protein: 7.2, carbs: 21.0, fat: 0.5 },
  }},
  { id: "11", name: "Garbanzo", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Garbanzos cocidos hervidos (USDA #173757)",
    per100g: { calories: 164, protein: 8.86, carbs: 27.4, fat: 2.59 },
    perPortion: { calories: 131.2, protein: 7.1, carbs: 21.9, fat: 2.1 },
  }},
  { id: "12", name: "Quinua", portion: "70 g cocido", grams: 70, nutrition: {
    sourceName: "Quinua cocida (USDA)",
    per100g: { calories: 120, protein: 4.4, carbs: 21.3, fat: 1.9 },
    perPortion: { calories: 84.0, protein: 3.1, carbs: 14.9, fat: 1.3 },
  }},
];

// ROMINA_DINNER_CARBS: Flattened (no spreads) to preserve stable indices.
// Original 15 items at positions 0-14, new items appended at 15+.
export const ROMINA_DINNER_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Avena cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Avena en hojuelas cruda (USDA)",
    per100g: { calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    perPortion: { calories: 97.3, protein: 4.2, carbs: 16.6, fat: 1.7 },
  }},
  /* 1 */ { id: "1", name: "Quinua cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Quinua cruda (USDA)",
    per100g: { calories: 368, protein: 14.1, carbs: 64.2, fat: 6.1 },
    perPortion: { calories: 92.0, protein: 3.5, carbs: 16.1, fat: 1.5 },
  }},
  /* 2 */ { id: "2", name: "Pan de molde", portion: "1 und", nutrition: {
    sourceName: "Pan de Molde Blanco Bimbo",
    per100g: { calories: 259, protein: 8.9, carbs: 44.1, fat: 4.2 },
    perPortion: { calories: 72.5, protein: 2.5, carbs: 12.3, fat: 1.2 },
  }},
  /* 3 */ { id: "3", name: "Pan pita", portion: "1 und", nutrition: {
    sourceName: "Pan Pita (USDA)",
    per100g: { calories: 275, protein: 9.1, carbs: 55.7, fat: 1.2 },
    perPortion: { calories: 123.8, protein: 4.1, carbs: 25.1, fat: 0.5 },
  }},
  /* 4 */ { id: "4", name: "Rapidita", portion: "1 und", nutrition: {
    sourceName: "Tortillas Rapiditas Clásicas Bimbo",
    per100g: { calories: 284, protein: 7.7, carbs: 48.1, fat: 6.7 },
    perPortion: { calories: 73.8, protein: 2.0, carbs: 12.5, fat: 1.7 },
  }},
  /* 5 */ { id: "5", name: "Tostada", portion: "1 und", nutrition: {
    sourceName: "Pan Tostado Clásico Bimbo",
    per100g: { calories: 400, protein: 10.5, carbs: 73, fat: 7.7 },
    perPortion: { calories: 64.0, protein: 1.7, carbs: 11.7, fat: 1.2 },
  }},
  /* 6 -- was "Fruta" placeholder, kept for backward compat */
  { id: "6", name: "Fruta (ver opciones de fruta)", portion: "1 opcion" },
  /* 7 */ { id: "7", name: "Arroz blanco", portion: "50 g", grams: 50, nutrition: {
    sourceName: "Arroz blanco cocido grano largo (USDA #168878)",
    per100g: { calories: 130, protein: 2.7, carbs: 28.2, fat: 0.3 },
    perPortion: { calories: 65, protein: 1.4, carbs: 14.1, fat: 0.2 },
  }},
  /* 8 */ { id: "8", name: "Arroz integral", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Arroz integral cocido grano largo (USDA #169704)",
    per100g: { calories: 123, protein: 2.7, carbs: 25.6, fat: 1.0 },
    perPortion: { calories: 86.1, protein: 1.9, carbs: 17.9, fat: 0.7 },
  }},
  /* 9 -- was "Menestras", renamed to Lentejas in-place */
  { id: "9", name: "Lentejas", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Lentejas cocidas hervidas (USDA #172421)",
    per100g: { calories: 116, protein: 9.0, carbs: 20.1, fat: 0.4 },
    perPortion: { calories: 92.8, protein: 7.2, carbs: 16.1, fat: 0.3 },
  }},
  /* 10 */ { id: "10", name: "Papa", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Papa hervida sin piel (USDA #170440)",
    per100g: { calories: 86, protein: 1.7, carbs: 20.0, fat: 0.1 },
    perPortion: { calories: 60.2, protein: 1.2, carbs: 14.0, fat: 0.1 },
  }},
  /* 11 */ { id: "11", name: "Yuca", portion: "45 g", grams: 45, nutrition: {
    sourceName: "Yuca cocida hervida (USDA estimado)",
    per100g: { calories: 155, protein: 1.4, carbs: 37.5, fat: 0.3 },
    perPortion: { calories: 69.8, protein: 0.6, carbs: 16.9, fat: 0.1 },
  }},
  /* 12 */ { id: "12", name: "Choclo", portion: "63 g", grams: 63, nutrition: {
    sourceName: "Maiz dulce amarillo cocido hervido (USDA #169999)",
    per100g: { calories: 96, protein: 3.4, carbs: 21.0, fat: 1.5 },
    perPortion: { calories: 60.5, protein: 2.1, carbs: 13.2, fat: 0.9 },
  }},
  /* 13 */ { id: "13", name: "Fideos blancos", portion: "48 g", grams: 48, nutrition: {
    sourceName: "Pasta cocida enriquecida (USDA #169737)",
    per100g: { calories: 158, protein: 5.8, carbs: 30.9, fat: 0.9 },
    perPortion: { calories: 75.8, protein: 2.8, carbs: 14.8, fat: 0.4 },
  }},
  /* 14 */ { id: "14", name: "Fideos integrales", portion: "53 g", grams: 53, nutrition: {
    sourceName: "Pasta integral cocida (USDA #168910)",
    per100g: { calories: 149, protein: 6.0, carbs: 30.1, fat: 1.7 },
    perPortion: { calories: 79.0, protein: 3.2, carbs: 16.0, fat: 0.9 },
  }},
  // ── New options (appended) ──
  { id: "15", name: "Arandanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arandanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "16", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
  { id: "17", name: "Mandarinas", portion: "2 und medianas (176 g)", grams: 176, nutrition: {
    sourceName: "Mandarina fresca (USDA)",
    per100g: { calories: 53, protein: 0.8, carbs: 13.3, fat: 0.3 },
    perPortion: { calories: 93.3, protein: 1.4, carbs: 23.4, fat: 0.5 },
  }},
  { id: "18", name: "Arvejita partida", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Arvejas partidas cocidas hervidas (USDA #175216)",
    per100g: { calories: 118, protein: 8.34, carbs: 21.1, fat: 0.4 },
    perPortion: { calories: 94.4, protein: 6.7, carbs: 16.9, fat: 0.3 },
  }},
  { id: "19", name: "Frejol", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Frijoles pintos cocidos hervidos (USDA #175194)",
    per100g: { calories: 143, protein: 9.0, carbs: 26.2, fat: 0.65 },
    perPortion: { calories: 114.4, protein: 7.2, carbs: 21.0, fat: 0.5 },
  }},
  { id: "20", name: "Garbanzo", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Garbanzos cocidos hervidos (USDA #173757)",
    per100g: { calories: 164, protein: 8.86, carbs: 27.4, fat: 2.59 },
    perPortion: { calories: 131.2, protein: 7.1, carbs: 21.9, fat: 2.1 },
  }},
  { id: "21", name: "Quinua", portion: "70 g cocido", grams: 70, nutrition: {
    sourceName: "Quinua cocida (USDA)",
    per100g: { calories: 120, protein: 4.4, carbs: 21.3, fat: 1.9 },
    perPortion: { calories: 84.0, protein: 3.1, carbs: 14.9, fat: 1.3 },
  }},
];

// ── Proteins ──

export const ROMINA_SMALL_PROTEINS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Huevo entero", portion: "1 und", nutrition: {
    sourceName: "Huevo de gallina entero crudo (USDA)",
    per100g: { calories: 155, protein: 12.6, carbs: 1.1, fat: 11.3 },
    perPortion: { calories: 77.5, protein: 6.3, carbs: 0.6, fat: 5.7 },
  }},
  /* 1 */ { id: "1", name: "Claras de huevo", portion: "2 und", nutrition: {
    sourceName: "Clara de huevo cruda (USDA)",
    per100g: { calories: 52, protein: 10.9, carbs: 0.7, fat: 0.2 },
    perPortion: { calories: 34.3, protein: 7.2, carbs: 0.5, fat: 0.1 },
  }},
  /* 2 */ { id: "2", name: "Pollo", portion: "40 g crudo", grams: 40, cookedGrams: 30, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 48.0, protein: 9.0, carbs: 0, fat: 1.0 },
  }},
  /* 3 */ { id: "3", name: "Yogurt griego Vakimu", portion: "150 g", grams: 150, nutrition: {
    sourceName: "Yogurt Griego Original Vakimu",
    per100g: { calories: 52, protein: 4.6, carbs: 1.4, fat: 3.1 },
    perPortion: { calories: 78.0, protein: 6.9, carbs: 2.1, fat: 4.7 },
  }},
  /* 4 */ { id: "4", name: "Queso cottage", portion: "50 g", grams: 50, nutrition: {
    sourceName: "Queso cottage (USDA)",
    per100g: { calories: 98, protein: 11.1, carbs: 3.4, fat: 4.3 },
    perPortion: { calories: 49.0, protein: 5.6, carbs: 1.7, fat: 2.2 },
  }},
  /* 5 */ { id: "5", name: "Queso mozzarella", portion: "30 g", grams: 30, nutrition: {
    sourceName: "Queso mozzarella (USDA)",
    per100g: { calories: 280, protein: 27.5, carbs: 3.1, fat: 17.1 },
    perPortion: { calories: 84.0, protein: 8.3, carbs: 0.9, fat: 5.1 },
  }},
  /* 6 */ { id: "6", name: "Vakimu Pro", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Vakimu +PRO",
    per100g: { calories: 69, protein: 8.8, carbs: 5, fat: 1.9 },
    perPortion: { calories: 55.2, protein: 7.0, carbs: 4.0, fat: 1.5 },
  }},
];

// Dinner proteins extend the small (breakfast) proteins with additional meat/fish
// options the nutritionist added for CENA only. Indices 0-6 match
// ROMINA_SMALL_PROTEINS so saved dinner plans remain stable; new items at 7+.
export const ROMINA_DINNER_PROTEINS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Huevo entero", portion: "1 und", nutrition: {
    sourceName: "Huevo de gallina entero crudo (USDA)",
    per100g: { calories: 155, protein: 12.6, carbs: 1.1, fat: 11.3 },
    perPortion: { calories: 77.5, protein: 6.3, carbs: 0.6, fat: 5.7 },
  }},
  /* 1 */ { id: "1", name: "Claras de huevo", portion: "2 und", nutrition: {
    sourceName: "Clara de huevo cruda (USDA)",
    per100g: { calories: 52, protein: 10.9, carbs: 0.7, fat: 0.2 },
    perPortion: { calories: 34.3, protein: 7.2, carbs: 0.5, fat: 0.1 },
  }},
  /* 2 */ { id: "2", name: "Pollo", portion: "40 g crudo", grams: 40, cookedGrams: 30, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 48.0, protein: 9.0, carbs: 0, fat: 1.0 },
  }},
  /* 3 */ { id: "3", name: "Yogurt griego Vakimu", portion: "150 g", grams: 150, nutrition: {
    sourceName: "Yogurt Griego Original Vakimu",
    per100g: { calories: 52, protein: 4.6, carbs: 1.4, fat: 3.1 },
    perPortion: { calories: 78.0, protein: 6.9, carbs: 2.1, fat: 4.7 },
  }},
  /* 4 */ { id: "4", name: "Queso cottage", portion: "50 g", grams: 50, nutrition: {
    sourceName: "Queso cottage (USDA)",
    per100g: { calories: 98, protein: 11.1, carbs: 3.4, fat: 4.3 },
    perPortion: { calories: 49.0, protein: 5.6, carbs: 1.7, fat: 2.2 },
  }},
  /* 5 */ { id: "5", name: "Queso mozzarella", portion: "30 g", grams: 30, nutrition: {
    sourceName: "Queso mozzarella (USDA)",
    per100g: { calories: 280, protein: 27.5, carbs: 3.1, fat: 17.1 },
    perPortion: { calories: 84.0, protein: 8.3, carbs: 0.9, fat: 5.1 },
  }},
  /* 6 */ { id: "6", name: "Vakimu Pro", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Vakimu +PRO",
    per100g: { calories: 69, protein: 8.8, carbs: 5, fat: 1.9 },
    perPortion: { calories: 55.2, protein: 7.0, carbs: 4.0, fat: 1.5 },
  }},
  // ── Dinner-only additions (nutritionist added carne/pescado to CENA) ──
  { id: "7", name: "Carne de res", portion: "35 g crudo", grams: 35, cookedGrams: 25, nutrition: {
    sourceName: "Carne de res magra cruda (USDA)",
    per100g: { calories: 143, protein: 21.4, carbs: 0, fat: 5.9 },
    perPortion: { calories: 50.1, protein: 7.5, carbs: 0, fat: 2.1 },
  }},
  { id: "8", name: "Pescado", portion: "35 g crudo", grams: 35, cookedGrams: 25, nutrition: {
    sourceName: "Tilapia cruda (USDA)",
    per100g: { calories: 96, protein: 20.1, carbs: 0, fat: 1.7 },
    perPortion: { calories: 33.6, protein: 7.0, carbs: 0, fat: 0.6 },
  }},
  { id: "9", name: "Carne molida", portion: "35 g crudo", grams: 35, cookedGrams: 25, nutrition: {
    sourceName: "Carne molida 90/10 cruda (USDA #174036)",
    per100g: { calories: 176, protein: 20.0, carbs: 0, fat: 10.0 },
    perPortion: { calories: 61.6, protein: 7.0, carbs: 0, fat: 3.5 },
  }},
];

export const ROMINA_LUNCH_PROTEINS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Pollo", portion: "280 g crudo", grams: 280, cookedGrams: 210, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 336.0, protein: 63.0, carbs: 0, fat: 7.3 },
  }},
  /* 1 */ { id: "1", name: "Pescado", portion: "245 g crudo", grams: 245, cookedGrams: 175, nutrition: {
    sourceName: "Tilapia cruda (USDA)",
    per100g: { calories: 96, protein: 20.1, carbs: 0, fat: 1.7 },
    perPortion: { calories: 235.2, protein: 49.2, carbs: 0, fat: 4.2 },
  }},
  /* 2 */ { id: "2", name: "Carne de res", portion: "245 g crudo", grams: 245, cookedGrams: 175, nutrition: {
    sourceName: "Carne de res magra cruda (USDA)",
    per100g: { calories: 143, protein: 21.4, carbs: 0, fat: 5.9 },
    perPortion: { calories: 350.4, protein: 52.4, carbs: 0, fat: 14.5 },
  }},
  /* 3 */ { id: "3", name: "Atún en conserva", portion: "210 g", grams: 210, nutrition: {
    sourceName: "Atún enlatado en agua (USDA)",
    per100g: { calories: 116, protein: 25.5, carbs: 0, fat: 0.8 },
    perPortion: { calories: 243.6, protein: 53.6, carbs: 0, fat: 1.7 },
  }},
  // ── New options (appended) ──
  { id: "4", name: "Carne molida", portion: "245 g crudo", grams: 245, cookedGrams: 175, nutrition: {
    sourceName: "Carne molida 90/10 cruda (USDA #174036)",
    per100g: { calories: 176, protein: 20.0, carbs: 0, fat: 10.0 },
    perPortion: { calories: 431.2, protein: 49.0, carbs: 0, fat: 24.5 },
  }},
];

// ── Fruits (standalone choice group) ──

export const ROMINA_FRUITS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Arandanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arandanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  /* 1 */ { id: "1", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
  /* 2 */ { id: "2", name: "Mandarinas", portion: "2 und medianas (176 g)", grams: 176, nutrition: {
    sourceName: "Mandarina fresca (USDA)",
    per100g: { calories: 53, protein: 0.8, carbs: 13.3, fat: 0.3 },
    perPortion: { calories: 93.3, protein: 1.4, carbs: 23.4, fat: 0.5 },
  }},
];

// ── Fats ──

export const ROMINA_FATS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Aceite de oliva", portion: "1 cdta", nutrition: {
    sourceName: "Aceite de oliva extra virgen (USDA)",
    per100g: { calories: 884, protein: 0, carbs: 0, fat: 100 },
    perPortion: { calories: 39.8, protein: 0, carbs: 0, fat: 4.5 },
  }},
  /* 1 */ { id: "1", name: "Palta", portion: "40 g", grams: 40, nutrition: {
    sourceName: "Aguacate/Palta (USDA)",
    per100g: { calories: 160, protein: 2.0, carbs: 8.5, fat: 14.7 },
    perPortion: { calories: 64.0, protein: 0.8, carbs: 3.4, fat: 5.9 },
  }},
  /* 2 */ { id: "2", name: "Aceitunas", portion: "6 und", nutrition: {
    sourceName: "Aceitunas verdes (USDA)",
    per100g: { calories: 145, protein: 1.0, carbs: 3.8, fat: 15.3 },
    perPortion: { calories: 26.1, protein: 0.2, carbs: 0.7, fat: 2.8 },
  }},
];

export const ROMINA_MID_AFTERNOON_FATS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Palta", portion: "40 g", grams: 40, nutrition: {
    sourceName: "Aguacate/Palta (USDA)",
    per100g: { calories: 160, protein: 2.0, carbs: 8.5, fat: 14.7 },
    perPortion: { calories: 64.0, protein: 0.8, carbs: 3.4, fat: 5.9 },
  }},
  /* 1 */ { id: "1", name: "Aceitunas", portion: "6 und", nutrition: {
    sourceName: "Aceitunas verdes (USDA)",
    per100g: { calories: 145, protein: 1.0, carbs: 3.8, fat: 15.3 },
    perPortion: { calories: 26.1, protein: 0.2, carbs: 0.7, fat: 2.8 },
  }},
];
